import { Container, ContainerProps } from '@mui/material';
import { MobileHeader } from 'components/Layout/Header/MobileHeader';
import { WebshopDesktopHeader } from 'components/Layout/components/WebshopDesktopHeader';
import { Breadcrumb } from 'generated/graphql';
import { ReactNode } from 'react';
import Footer from '../Footer/Footer';
import Header from './Header/Header';
import { CustomBreadcrumbs } from './components/CustomBreadcrumbs';

type LayoutProps = {
    children: ReactNode;
    showBreadcrumbs?: true;
    breadcrumbs?: Breadcrumb[];
    containerProps?: ContainerProps;
};

export default function Layout({ children, showBreadcrumbs, breadcrumbs, containerProps }: LayoutProps) {
    return (
        <>
            <Header
                desktopHeader={() => (
                    <WebshopDesktopHeader />
                )}
                mobileHeader={(isOpen, toggleDrawer) => (
                    <MobileHeader
                        isOpen={isOpen}
                        toggleDrawer={toggleDrawer}
                    />
                )}
                breakpoint="lg"
            />
            <Container
                maxWidth={false}
                {...containerProps}
                sx={{
                    maxWidth: '1300px',
                    paddingTop: 2,
                    paddingBottom: 2,
                    ...containerProps?.sx,
                }}
            >
                { showBreadcrumbs ? <CustomBreadcrumbs breadcrumbs={breadcrumbs} /> : null }
                {children}
            </Container>
            <Footer isStartPage />
        </>
    );
}
